import { useState } from 'react';
import { Title } from 'react-admin';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { AftercareList } from '../funerals/AftercareList';
import { AftercareReport } from './AftercareReport';

/** /aftercare: the families list (unchanged) and the Report tab (T-209). */
export const AftercarePage = () => {
  const [tab, setTab] = useState('families');
  return (
    <Tabs value={tab} onValueChange={setTab}>
      <TabsList className="mt-2 border-b border-border">
        <TabsTrigger value="families">Families</TabsTrigger>
        <TabsTrigger value="report">Report</TabsTrigger>
      </TabsList>
      <TabsContent value="families">
        <AftercareList />
      </TabsContent>
      <TabsContent value="report">
        <Title title="Aftercare" />
        <AftercareReport />
      </TabsContent>
    </Tabs>
  );
};

export default AftercarePage;
